export function reload(): void {
	window.location.reload();
}
